<template>
  <div class="legend_wraper" v-show="topicLegends.length > 0">
    <!-- 图例左侧 -->
    <!-- <div v-if="$route.name=='经济运行'">
      <img src="../../../public/img/legend/legend_jindu.png" alt />
    </div>-->
    <div class="legend_list">
      <div
        class="legned_item"
        v-for="(item, index) of topicLegends"
        :key="index"
        @click="select(item)"
      >
        <div class="icon">
          <img :src="item.img" alt />
        </div>
        <div class="txt">{{ item.txt }}</div>
        <div class="checkbox">
          <div :class="item.checked ? 'active' : ''"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'legend_wraper',
  props: {
    topicLegends: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    //勾选散点
    select(legend) {
      legend.checked = !legend.checked
      this.$emit('legendClick', legend)
    },
  },
  created() {},
  computed: {
    ...mapState(['topic']),
    // 删选出不需要显示的图例
  },
  mounted() {},
  watch: {},
}
</script>

<style lang="less" scoped>
.legend_wraper {
  display: flex;
  justify-content: space-between;
  background: rgba(23, 36, 53, 0.6);
  border-top: solid 1px #29e4f5;
  padding: 10px 20px 1px;
}
.legend_list {
  width: 300px;
  box-sizing: border-box;
  pointer-events: all;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .legned_item {
    width: 290px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .icon {
      width: 30px;
      margin-right: 5px;
      & > img {
        max-width: 40px;
      }
    }
    .txt {
      width: 190px;
      white-space: nowrap;
      overflow: hidden;
      font-size: 24px;
      background-image: -webkit-linear-gradient(top, #fff, #c5fbfc);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: 'Helvetica';
    }
    .checkbox {
      width: 30px;
      height: 30px;
      border: solid 1px rgba(255, 255, 255, 0.85);
      box-sizing: border-box;
      // background: rgba(26, 53, 81, 0.85);
      cursor: pointer;
      .active {
        width: 23px;
        height: 23px;
        background: url('../../../public/img/legend/legend_checked.png')
          no-repeat;
        background-size: 20px 20px;
        background-position: 2px 4px;
        cursor: pointer;
      }
    }
  }
}
.legend_wraper2 {
  width: 450px;
  background: rgba(23, 36, 53, 0.6);
  border-top: solid 1px #29e4f5;
  padding: 10px 20px 1px;
  pointer-events: all;
  & > div {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .legned_item {
      width: 130px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .icon {
        width: 40px;
      }
      .txt {
        width: 90px;
        font-size: 14px;
        background-image: -webkit-linear-gradient(top, #fff, #c5fbfc);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-family: 'PingFang SC';
      }
      .checkbox {
        width: 20px;
        height: 20px;
        border: solid 1px rgba(255, 255, 255, 0.85);
        box-sizing: border-box;
        // background: rgba(26, 53, 81, 0.85);
        cursor: pointer;
        .active {
          width: 13px;
          height: 13px;
          background: url('../../../public/img/legend/legend_checked.png')
            no-repeat;
          background-size: 10px 10px;
          background-position: 2px 4px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
